import {
  Design,
  DesignClass,
  DesignModule,
  DesignModuleNode,
  DesignModuleNodeConfig,
  DesignObject,
  ExitObjectConfig,
  NodeTypeName,
  ObjectClass
} from '@app/types';

function setSensitive(
  item: {
    sensitive?: boolean;
    sensitiveData?: boolean;
  },
  value: boolean
): void {
  if ('sensitiveData' in item) {
    item.sensitiveData = value;
  }
  if ('sensitive' in item) {
    item.sensitive = value;
  }
}

function setSensitiveOnItem(
  item: DesignModule | DesignModuleNode | DesignObject | undefined,
  value: boolean
): void {
  if (!item) {
    return;
  }
  if ('localVariables' in item) {
    item.localVariables?.forEach((lv) => {
      setSensitive(lv.props.config, value);
    });
  }

  if (item._class === DesignClass.module && item.props.config.sensitiveOverrides) {
    item.props.config.sensitiveOverrides = {
      enabled: false,
      lastLocalChange: window.apm.timestamp
    };
    window.apm.postEventToAllViews({
      target: 'request-refresh',
      event: {
        id: item.id,
        type: 'node',
        upDatedField: 'sensitiveOverrides',
        props: item.props,
        newValue: item.props.config.sensitiveOverrides
      }
    });
  }

  if (item.props.nodeTypeName === NodeTypeName.input) {
    setSensitive(item.props.config, value);
  }

  if (item.props.config.inputs) {
    item.props.config.inputs.forEach((inp) => {
      setSensitive(inp, value);
    });
  }

  if (
    item.props.config.outputs
    && item._class !== ObjectClass.exit
  ) {
    const outputs = item.props.config.outputs as Exclude<
      DesignModuleNodeConfig['outputs'],
      // Exit nodes are filtered out above.
      ExitObjectConfig['outputs']
    >;

    outputs!.forEach((oup) => {
      setSensitive(oup, value);
    });
  }
  item.props.lastLocalChange = window.apm.timestamp;
}

/** Add branching event to the design. */
export function resetCommonModuleLocalVariablesNotSensitive(
  commonModuleId: string,
  serialized: Design
): void {
  const moduleMatch = serialized.components.modules.find((mod) => {
    return mod.id === commonModuleId;
  });
  if (!moduleMatch) {
    return;
  }

  const { moduleApp } = moduleMatch.props;
  [
    ...serialized.components.modules,
    ...serialized.components.objects
  ].forEach((item) => {
    if (item.props.moduleApp === moduleApp) {
      setSensitiveOnItem(item, false);
    }
    if ('versions' in item) {
      item.versions[1].flow.nodes.forEach((node) => {
        if (node.props.moduleApp === moduleApp) {
          setSensitiveOnItem(node, false);
        }
      });
    }
  });
}
